
export default function Garantia() {
  return null;
}
